import * as React from 'react';
const Translate = require('react-redux-i18n').Translate;
var I18n = require('react-redux-i18n').I18n;
import * as version from '../../utils/version';
import { connect, Dispatch } from 'react-redux';
import { Api } from '../../typings/api';
import { StoreState } from '../../reducers';
import { StyledHeader, PageTitle } from '../MenuManager/Header/styles';
import { BackButton } from '../DriveItemDetailPage/styles';
import {
	Content,
	GalleryCover, GalleryCoverContainer, GalleryCoverImg, GalleryCoverName,
	AppInfosContainer, AppInfos, ButtonContainer,
	GalleryDescriptionContainer, GalleryDescriptionTitle, GalleryDescriptionContent, GalleryDescriptionContentLine
} from './styles';
import { fetchDriveItem } from '../DriveItemList/actions';
import { GalleryInfosState } from '../Gallery/reducer';
import { DriveListState } from '../DriveItemList/reducer';
import DriveItemDeleteButton from '../DriveItem/DeleteButton';
import DriveItemDownloadButton from '../DriveItem/DownloadButton';
import { DownloadManagerState, DownloadMode } from '../DownloadManager/reducer';
import AppInfo from './AppInfo';
import Utils from '../../utils';
import UserAgentUtils from '../../utils/userAgent';
import NativeApiUtil from '../../utils/nativeApi';
import DriveItemUtils, { ActionButtonStyle } from '../../utils/driveItem';
import DownloadManagerUtils from '../../utils/downloadManager';
import { ParametersPageState } from './reducer';
import { setUsedSpace, setFreeSpace } from './actions';

export interface ParametersPageProps {
	dispatch: Dispatch<StoreState>;
	driveList: DriveListState;
	galleryInfos: GalleryInfosState;
	parametersPage: ParametersPageState;
	downloadManager: DownloadManagerState;
}

export class ParametersPage extends React.Component<ParametersPageProps, {}> {

	description: string;
	thumbSrc: string | undefined;
	name: string;

	constructor(props: ParametersPageProps) {
		super(props);
		this.leavePage = this.leavePage.bind(this);

		if (UserAgentUtils.isMobileApp) {
			this.setAppSpaceInfos();
		}
	}

	leavePage = (): void => {
		window.history.back();
	}

	render() {
		const { dispatch, driveList, galleryInfos, downloadManager, parametersPage } = this.props;
		const { items } = downloadManager;
		const { usedSpace, freeSpace } = parametersPage;
		const galleryId = galleryInfos.config.applicationGallery;

		if (galleryId) {
			const galleryFolder = driveList.driveItems[galleryId];
			if (galleryFolder) {
				this.setAppFields(galleryFolder);
			} else {
				dispatch(fetchDriveItem(galleryId));
			}
		}

		const downloadsIds = Object.keys(items);

		const hasItemsToDownload = DownloadManagerUtils.hasItemsToDownload(downloadManager, driveList, galleryInfos);

		let hasDownloadedItems = false;
		downloadsIds.forEach(key => {
			const item = items[key];

			if (!hasDownloadedItems && item.mode !== DownloadMode.Required) {
				hasDownloadedItems = true;
			}
		});

		return (
			<div>
				<StyledHeader>
					<div>
						<BackButton onClick={this.leavePage}>
							{Utils.getSvgIcon('iconset_back')}
						</BackButton>
					</div>
					<PageTitle><Translate value="messages.parameters" /></PageTitle>
					<div/>
				</StyledHeader>
				<Content>
					<GalleryCover>
						<GalleryCoverContainer>
							<GalleryCoverImg
								imageUrl={this.thumbSrc}
							/>
							<GalleryCoverName>
								{this.name}
							</GalleryCoverName>
						</GalleryCoverContainer>
					</GalleryCover>
					<AppInfosContainer>
						<AppInfos>
							<AppInfo
								key="usedSpace"
								title={I18n.t('messages.used_space')}
								value={usedSpace}
							/>
							<AppInfo
								key="freeSpace"
								title={I18n.t('messages.free_space')}
								value={freeSpace}
							/>
							<AppInfo
								key="version"
								title={I18n.t('messages.version')}
								value={version}
							/>
							<ButtonContainer>
								{ hasDownloadedItems &&
									<DriveItemDeleteButton style={ActionButtonStyle.ParametersPage} />
								}
								{ hasItemsToDownload &&
									<DriveItemDownloadButton style={ActionButtonStyle.ParametersPage} />
								}
							</ButtonContainer>
						</AppInfos>
					</AppInfosContainer>
					<GalleryDescriptionContainer>
						<GalleryDescriptionTitle>
							<Translate value="messages.informations" />
						</GalleryDescriptionTitle>
						<GalleryDescriptionContent>
							{this.renderDescription(this.description)}
						</GalleryDescriptionContent>
					</GalleryDescriptionContainer>
				</Content>
			</div>
		);
	}

	setAppFields(galleryFolder: Api.DriveFolderInfo) {
		const { driveList, galleryInfos } = this.props;
		const { resolutions } = driveList;

		if (galleryFolder) {
			const descriptions = galleryFolder.descriptions;
			const language = 'en_US';
			if (descriptions && descriptions[language]) {
				this.description = descriptions[language];
			}

			this.thumbSrc = galleryFolder.icon ?
				DriveItemUtils.getThumbnail(galleryFolder, galleryInfos.config, resolutions, true) :
				undefined;

			this.name = galleryFolder.label;
		}
	}

	setAppSpaceInfos() {
		const { dispatch } = this.props;
		NativeApiUtil.getUsedSpace().then(
			value => {
				dispatch(setUsedSpace(Utils.formatFileSize(value)));
			}
		);

		NativeApiUtil.getFreeSpace().then(
			value => {
				dispatch(setFreeSpace(Utils.formatFileSize(value)));
			}
		);
	}

	renderDescription(description: string) {
		if (!description) {
			return null;
		}

		return (
			<GalleryDescriptionContentLine
				dangerouslySetInnerHTML={{ __html: Utils.nl2br(description) }}
			/>
		);
	}
}

const mapStateToProps = (state: StoreState) => {
	const { galleryInfos, driveList, parametersPage, downloadManager } = state;
	return { galleryInfos, driveList, parametersPage, downloadManager };
};

export default connect(mapStateToProps)(ParametersPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/index.tsx